import React from 'react';

interface UseTimerProps {
  onTimeOver: () => void;
  delayInMs: number;
}

const useTimer = ({ onTimeOver, delayInMs }: UseTimerProps) => {
  let timeoutID: any;

  const runFunction = () => {
    if (delayInMs === 0) {
      return;
    }

    timeoutID = setTimeout(() => {
      onTimeOver();
    }, delayInMs);
  };

  React.useEffect(() => {
    runFunction();
    return () => {
      clearTimeout(timeoutID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeoutID]);
};

export default useTimer;
